import styled from 'styled-components';

const ToolbarRight = styled.div({
  display: 'flex',
  flex: '0 0 auto',
});

export { ToolbarRight };
